export default "__VITE_ASSET__BosA1po___"